import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "d-flex align-items-center mb-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn"
}
const _hoisted_10 = {
  filter: "name",
  sort: "anagrafica.name"
}
const _hoisted_11 = {
  filter: "surname",
  sort: "anagrafica.surname"
}
const _hoisted_12 = {
  filter: "assignedOn",
  filterType: "date",
  sort: "assignedOn"
}
const _hoisted_13 = {
  filter: "acceptedOn",
  filterType: "date",
  sort: "acceptedOn"
}
const _hoisted_14 = {
  filter: "assignedTo.name",
  sort: "assignedTo.name"
}
const _hoisted_15 = {
  filter: "reteCommercialeParent.name",
  sort: "reteCommercialeParent.name"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { colspan: "99" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Mai assegnato")
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Accettazione clienti e lead",
          text: "Accettazione clienti e lead"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.selectedLeads.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary mr-1",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.assignSelected && _ctx.assignSelected(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Assegna clienti selezionati",
                text: "Assegna clienti selezionati"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.acceptSelected && _ctx.acceptSelected(...args))),
          disabled: _ctx.selectedLeads.length == 0
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Accetta tutti i clienti selezionati",
            text: "Accetta tutti i clienti selezionati"
          })
        ], 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_toggler, {
        modelValue: _ctx.showAccepted,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showAccepted) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_component_localized_text, {
          localizedKey: "Mostra accettati",
          text: "Mostra accettati"
        })
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.items
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-check",
                onClick: ($event: any) => (_ctx.checkall(opData.items))
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_10, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_11, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cognome",
                text: "Cognome"
              })
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data assegnazione",
                text: "Data assegnazione"
              })
            ]),
            _createElementVNode("td", _hoisted_13, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data accettazione",
                text: "Data accettazione"
              })
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "Assegnato a",
                text: "Assegnato a"
              })
            ]),
            _createElementVNode("td", _hoisted_15, [
              _createVNode(_component_localized_text, {
                localizedKey: "Rete commerciale",
                text: "Rete commerciale"
              })
            ]),
            _hoisted_16
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", _hoisted_18, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.LeadInAccettazioneVm[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: i,
              class: _normalizeClass(_ctx.getRitardoClass(item))
            }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLeads) = $event)),
                  value: item.identifier
                }, null, 8, _hoisted_19), [
                  [_vModelCheckbox, _ctx.selectedLeads]
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.surname), 1),
              _createElementVNode("td", null, [
                (item.assignedOn == '0001-01-01T00:00:00')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_20
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.date(item.assignedOn, "YYYY-MM-DD HH:mm")), 1)
                    ], 64))
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.acceptedOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, [
                (item.assignedTo)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(item.assignedTo.name), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_localized_text, {
                      key: 1,
                      localizedKey: "NESSUNO",
                      text: "NESSUNO"
                    }))
              ]),
              _createElementVNode("td", null, _toDisplayString(item.reteCommercialeParent && item.reteCommercialeParent.name), 1),
              _createElementVNode("td", null, [
                (!item.acceptedOn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.accept(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Accetta",
                        text: "Accetta"
                      })
                    ], 8, _hoisted_21))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}